import { motion } from "framer-motion";

const STEPS = [
  ["01", "Herb Sourcing", "Ethically sourced, single-origin herbs, inspected on intake for identity and quality."],
  ["02", "Standardised Extraction", "Actives standardised in a controlled lab to guarantee potency in every batch."],
  ["03", "Formulation & Blending", "Classical and proprietary formulas blended under strict GMP conditions."],
  ["04", "Quality Testing", "Multi-stage QC — heavy metals, microbial, potency — before release."],
  ["05", "Packaging & Dispatch", "Precision filling, tamper-proof packaging and fast pan-India dispatch."],
];

export default function Process() {
  return (
    <section className="bg-[#f9f8f5] py-20 md:py-28" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="eyebrow text-[#d46a1d]">How We Manufacture</div>
          <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#202124] md:text-5xl">
            Five steps, zero compromise
          </h2>
        </div>

        <div className="relative mt-16">
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-[#e7e0d6] lg:block" />
          <div className="grid gap-8 lg:grid-cols-5">
            {STEPS.map(([n, title, body], i) => (
              <motion.div key={n}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="relative text-center lg:text-left" data-testid={`process-step-${i}`}>
                <div className="mx-auto grid h-14 w-14 place-items-center rounded-full border border-[#e7e0d6] bg-white font-serif text-xl text-[#d46a1d] card-shadow lg:mx-0">
                  {n}
                </div>
                <h3 className="mt-5 font-serif text-xl text-[#202124]">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#6b6a65]">{body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
